import { render, staticRenderFns } from "./cargoDocExtendOtherCopyDialog.vue?vue&type=template&id=4f51e686&"
import script from "./cargoDocExtendOtherCopyDialog.vue?vue&type=script&lang=js&"
export * from "./cargoDocExtendOtherCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f51e686')) {
      api.createRecord('4f51e686', component.options)
    } else {
      api.reload('4f51e686', component.options)
    }
    module.hot.accept("./cargoDocExtendOtherCopyDialog.vue?vue&type=template&id=4f51e686&", function () {
      api.rerender('4f51e686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/cargoDocExtendOtherCopyDialog.vue"
export default component.exports